/* eslint-disable */

export enum SaleStatus {
	NotDefined = 0,
	Expired = 1,
	NotInStock = 2,
	InStock = 3,
	Active = 4,
	InActive = 5,
	
}
